<!-- APP--APP管理--支付配置 -->
<template>
  <div>
    <!-- 表单-阿里 -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("state")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-select v-model="form.state">
              <md-option value="1">{{$I18n("open")}}</md-option>
              <md-option value="2">{{$I18n("close")}}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-微信 -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("user_pri_dk")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-chips v-model="form.user_pri_dk" class="no-top" :md-placeholder="''" style="margin: 0;padding: 0;"/>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-微信 -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("dev_ver_code")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-input v-model="form.dev_ver_num" />
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-paypal -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("dev_public_dk")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-chips v-model="form.dev_pub_dk" class="no-top" :md-placeholder="''" style="margin: 0;padding: 0;"/>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-paypal -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("dev_private_dk")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-chips v-model="form.dev_pri_dk" class="no-top" :md-placeholder="''" style="margin: 0;padding: 0;"/>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-paypal -->
    <div class="md-layout">
      <div class="md-layout md-layout-item md-size-60 mx-auto md-xsmall-size-100"> 
        <label class="md-layout-item md-size-20 md-form-label md-form-label-out">{{$I18n("dev_oem_pre")}}:</label>
        <div class="md-layout-item md-size-80 md-form-item">
          <md-field>
            <md-chips v-model="form.dev_oem_prefix" class="no-top" :md-placeholder="''" style="margin: 0;padding: 0;"/>
          </md-field>
        </div>
      </div>
    </div>
    <!-- 表单-提交按钮 -->
    <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
 },
  data(){
    return {
      modal: false, // 弹窗是否打开了
      form : {      // 表单选择的数据
        state      : 1,
        user_pri_dk    : [],
        dev_ver_num    : "",
        dev_pub_dk     : [],
        dev_pri_dk     : [],
        dev_oem_prefix : [],
      },
    }
  },
  methods: {
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    modal_submit(){ // 弹窗-提交修改
      this.$api.setAppCfg({ // api: /pay/appid/set
        data_limit:{
          ...this.form,
          master_id: this.app_id,
          user_pri_dk:     JSON.stringify(this.form.user_pri_dk),
          dev_oem_prefix : JSON.stringify(this.form.dev_oem_prefix),
          dev_pri_dk :     JSON.stringify(this.form.dev_pri_dk),
          dev_pub_dk :     JSON.stringify(this.form.dev_pub_dk),
        },
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.modal_closeModal();
          this.api_getAppSet();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    api_getAppSet(){ // API-获取对应 "APP ID" 的支付配置
      this.form = { 
        state      : 1,
        dev_ver_num    : "",
        user_pri_dk    : [],
        dev_pub_dk     : [],
        dev_pri_dk     : [],
        dev_oem_prefix : [],
      }
      return this.$api.getAppCfg({ // api: /pay/appid/query
        img: {master_id:this.app_id,},
        data_limit: {master_id:this.app_id,},
      })
        .then(this.$Then(res => {
          if(!res.data.data_limit || !res.data.data_limit.state){
            return
          }
          try{
            this.form = {
              ...res.data.data_limit,
              dev_oem_prefix : res.data.data_limit.dev_oem_prefix?JSON.parse(res.data.data_limit.dev_oem_prefix) :[],
              dev_pri_dk     : res.data.data_limit.dev_pri_dk    ?JSON.parse(res.data.data_limit.dev_pri_dk) :[],
              dev_pub_dk     : res.data.data_limit.dev_pub_dk    ?JSON.parse(res.data.data_limit.dev_pub_dk) :[],
              user_pri_dk    : res.data.data_limit.user_pri_dk   ?JSON.parse(res.data.data_limit.user_pri_dk) :[],
            }
          } catch (e) {
            this.form = { 
              state      : 1,
              dev_ver_num    : "",
              user_pri_dk    : [],
              dev_pub_dk     : [],
              dev_pri_dk     : [],
              dev_oem_prefix : [],
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.form = { 
            state      : 1,
            dev_ver_num    : "",
            user_pri_dk    : [],
            dev_pub_dk     : [],
            dev_pri_dk     : [],
            dev_oem_prefix : [],
          }
        }))
    },
  },
  created(){
    this.api_getAppSet()
  },
}
</script>